import React from "react";
import { Link } from "react-router-dom";
import serviceList from "../scripts/serviceList";

const ServiceAreaGroup = () => {
  return (
    <>
      {/*=================== service area start ===================*/}
      <div className='service-area bg-relative pd-top-100 pd-bottom-100'>
        <div className='container'>
          <div className='section-title text-center'>
            <h6 className='sub-title'>OUR PRODUCTS</h6>
            <h2 className='title'>
              We Are the Experts in <span>Steel, SS and Aluminium</span> Forgings
            </h2>
          </div>
          <div className='row'>
            {serviceList.map((data, index) => (
              <div className='col-lg-4 col-md-6' key={index}>
                <Link to={data.link}>
                  <div className='single-service-inner text-center'>
                    <div className='thumb'>
                      <img src={data.img} alt='img' width="190" height="190" />
                    </div>
                    <div className='details'>
                      <h5>
                        <Link to={data.link}>{data.title}</Link>
                      </h5>
                      <p>{data.des}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* =================== service area end ===================*/}
    </>
  );
};

export default ServiceAreaGroup;
